import { User } from '../../../store/types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/system'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Checkbox, FormControlLabel, Tooltip, Typography } from '@mui/material'
import CollapsibleSection from '../../Button/CollapsibleSection'
import { useLeftPadding } from '../../../store/redux/hooks'

const UserInfiniteScroll = ({
  displayedUsers,
  fetchMore,
  hasMore,
  selectedUsers,
  handleUserCheck,
}: {
  displayedUsers: User[]
  fetchMore: () => void
  hasMore: boolean
  selectedUsers: string[]
  handleUserCheck: (event: React.ChangeEvent<HTMLInputElement>) => void
}) => {
  const { t } = useTranslation()
  const leftPadding = useLeftPadding()
  return (
    <CollapsibleSection text={t('page.adminsPage.filtering.employees')}>
      <Box
        sx={{
          height: 150,
          overflowY: 'auto',
          overflowX: 'hidden',
          '::-webkit-scrollbar': {
            width: '6px',
            backgroundColor: 'background.elevation5',
            borderRadius: '10px',
            ml: 1,
          },
          '::-webkit-scrollbar-thumb': {
            backgroundColor: 'secondary.main',
            borderRadius: '10px',
            ml: 1,
          },
        }}
        id="scrollableDivUsers"
      >
        <InfiniteScroll
          dataLength={displayedUsers.length}
          next={fetchMore}
          hasMore={hasMore}
          loader={
            <span>
              <i>{t('components.infiniteScroll.loading')}</i>
            </span>
          }
          scrollableTarget={'scrollableDivUsers'}
          style={{ overflowX: 'hidden', display: 'flex', flexDirection: 'column' }}
          endMessage={
            <Typography variant="body2" align="center" paddingY={2}>
              <i>{t('components.infiniteScroll.endMessage.employees')}</i>
            </Typography>
          }
        >
          {displayedUsers.map((user, index) => (
            <Tooltip
              title={`${user.firstName} ${user.lastName}`}
              placement={'right'}
              key={`${user.id}-${index}-user-filtering-menu-item-tooltip`}
            >
              <FormControlLabel
                sx={{ pl: leftPadding }}
                control={
                  <Checkbox value={user.id} checked={selectedUsers.includes(user.id)} onChange={handleUserCheck} />
                }
                label={
                  <Typography
                    sx={{
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {`${user.firstName} ${user.lastName}`}
                  </Typography>
                }
              />
            </Tooltip>
          ))}
        </InfiniteScroll>
      </Box>
    </CollapsibleSection>
  )
}

export default UserInfiniteScroll
